import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useOnboardingCheck = () => {
  const { user, userRoles } = useAuth();

  const { data: hasChildren, isLoading } = useQuery({
    queryKey: ["onboarding-check", user?.id],
    queryFn: async () => {
      if (!user) return false;

      // Super admins can bypass onboarding
      if (userRoles.includes('super_admin')) return true;

      // Check if user is a parent and has children
      if (userRoles.includes('parent')) {
        const { data, error } = await supabase
          .from("parent_child_relationships")
          .select("child_id")
          .eq("parent_id", user.id)
          .limit(1);

        if (error) {
          console.error("Error checking children:", error);
          return false;
        }

        return (data?.length || 0) > 0;
      }

      // Non-parents can proceed (students, teachers, etc.)
      return true;
    },
    enabled: !!user,
  });

  return { hasChildren, isLoading, needsOnboarding: !hasChildren && !isLoading };
};
